export default __webpack_public_path__ + "static/media/options.7c0decb7.svg";